import { FormattedMessage } from 'react-intl';
import messages from '../messages';

export const NAME = 'manage-hud-vouchers';

export const HEADERS = [
  {
    id: 'voucherYearMonth',
    label: <FormattedMessage {...messages.voucherYearMonth} />,
    sortable: true,
    searchable: true,
    dataType: 'date',
  },
  {
    id: 'tracsVoucherId',
    label: <FormattedMessage {...messages.tracsVoucherId} />,
    sortable: false,
    searchable: true,
    dataType: 'string',
  },
  {
    id: 'subsidyUnits',
    label: <FormattedMessage {...messages.subsidyUnits} />,
    sortable: true,
    searchable: true,
    dataType: 'number',
  },
  {
    id: 'subsidyType',
    label: <FormattedMessage {...messages.subsidyType} />,
    sortable: false,
    multiselect: true,
    dataType: 'string',
  },
  {
    id: 'contractNumber',
    label: <FormattedMessage {...messages.contractNumber} />,
    sortable: true,
    dataType: 'string',
  },
  {
    id: 'submissionStatus',
    label: <FormattedMessage {...messages.submissionStatus} />,
    sortable: true,
    multiselect: true,
    dataType: 'string',
  },
  {
    id: 'lastSubmissionDate',
    label: <FormattedMessage {...messages.lastSubmissionDate} />,
    sortable: true,
    dataType: 'date',
  },
  {
    id: 'totalVoucherAmount',
    label: <FormattedMessage {...messages.totalVoucherAmount} />,
    sortable: true,
    dataType: 'number',
  },
  {
    id: 'actions',
    label: <FormattedMessage {...messages.actions} />,
    sortable: false,
    dataType: 'string',
    defaultWidth: 100,
  },
];
